import { isbot } from 'isbot';
import { cookie } from '@farmersdog/lead-browser-storage';

import type { HomepageEndToEndRedesignTreatments } from 'src/abTesting';
import { useSsrFeature } from 'src/abTesting';
import { AC_HOMEPAGE_END_TO_END_REDESIGN } from 'src/abTesting/features';

import {
  activeHomepageRedesignTreatments,
  type ActiveHomepageRedesignTreatment,
} from './types';
import { useReferrer } from '../useReferrer';

export interface UseShowHomePageE2ERedesignReturnType {
  shouldShowHomepageRedesign: boolean;
  treatment: HomepageEndToEndRedesignTreatments;
}

export const useShowHomepageRedesign =
  (): UseShowHomePageE2ERedesignReturnType => {
    const isBot = isbot(navigator.userAgent);
    const { couponCode } = useReferrer();
    const utmSource = cookie.getUtmSource() ?? '';

    const { treatment } = useSsrFeature<
      typeof AC_HOMEPAGE_END_TO_END_REDESIGN,
      HomepageEndToEndRedesignTreatments
    >({
      featureKey: AC_HOMEPAGE_END_TO_END_REDESIGN,
      attributes: {
        isBot,
        referrerCode: couponCode ?? '',
        utmSource,
      },
    });

    const shouldShowHomepageRedesign = treatment
      ? activeHomepageRedesignTreatments.includes(
          treatment as ActiveHomepageRedesignTreatment
        )
      : false;

    return {
      shouldShowHomepageRedesign,
      treatment,
    };
  };
